import { OrdersActions } from "../../types";

const initialState: any = {
  loading: false,
  data: {
    order_manage_attachments: true,
    order_delete_attachments: true,
    order_manage_notes: true,
    order_delete_notes: true,
    order_delete_order: true,
    order_add_ordered_item: true,
    order_delete_ordered_item: true,
    order_edit_ordered_item: true,
    order_add_schedule_order: true,
    order_delete_schedule_order: true,
    order_edit_schedule_order: true,
  },
};

export default function (state: any = initialState, action: any) {
  switch (action.type) {
    case OrdersActions.StoreInitialState:
      return {
        ...state,
        data: action.payload.permissions || initialState.data,
      };

    default:
      return state;
  }
}
